import { CommonRequestOptions, makeRequest } from '../makeRequest';

export type SignoffConfigForStep = {
   type: 'self' | 'team' | 'none';
   team?: {
      teamid: number;
      name: string;
      avatarUrl: string;
   };
};

export async function getSignoffConfigForStep(
   stepid: number,
   { ...common }: CommonRequestOptions = {}
): Promise<SignoffConfigForStep> {
   return makeRequest('get', `/signoffs/${stepid}`, {
      ...common,
   });
}
